import { stats } from '@fiverr-private/obs';

const PACKAGE_NAME = 'go_shared_ui';

export const metric = stats.prefix(`packages.${PACKAGE_NAME}`);
